import useHash from '../../Hooks/UseHash';
import { NextBooking, PublicLiabilityInsuranceWithDocuments } from '../../Services/InsuranceLicenseService';
import InsuranceDocumentLinks from './InsuranceDocumentLinks';
import { bookingHeader, bookingStatus, formatUnixDate } from './InsuranceLicenseUtils';

type Props = {
	policies: PublicLiabilityInsuranceWithDocuments[];
	firstBookingForStatus: NextBooking;
	firstBooking?: NextBooking;
	secondBooking?: NextBooking;
	removingPolicyId: number | null;
	onRemovePolicy: (policyId: number) => void;
};

export default function LiabilityInsuranceMobileList(props: Props) {
	const { policies, firstBookingForStatus, firstBooking, secondBooking, removingPolicyId, onRemovePolicy } = props;
	const hash = useHash();

	return (
		<div className="insurance-license-mobile-list">
			{policies.map((policy) => {
				const firstStatus = bookingStatus(policy, firstBookingForStatus);
				const secondStatus = bookingStatus(policy, secondBooking);
				return (
					<div className="insurance-license-mobile-card" key={policy.PublicLiabilityInsuranceId}>
						<div className="insurance-license-mobile-card-header">
							<div className="insurance-license-mobile-title">
								{policy.PublicLiabilityInsuranceIssuedBy || 'Insurance policy'}
							</div>
							<div className="insurance-license-mobile-subtitle">
								Expires {formatUnixDate(policy.PublicLiabilityInsuranceExpiry) || 'Unknown'}
							</div>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">Policy number</span>
							<span>{policy.PublicLiabilityInsuranceNumber || '-'}</span>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">Valid from</span>
							<span>{formatUnixDate(policy.PublicLiabilityInsuranceValidFrom) || '-'}</span>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">Expiry</span>
							<span>{formatUnixDate(policy.PublicLiabilityInsuranceExpiry) || '-'}</span>
						</div>
						<div className="insurance-license-mobile-row insurance-license-mobile-row--documents">
							<span className="insurance-license-mobile-label">Documents</span>
							<span>
								<InsuranceDocumentLinks documents={policy.Documents} hash={hash} />
							</span>
						</div>
						{firstStatus ? (
							<div className="insurance-license-mobile-row">
								<span className="insurance-license-mobile-label">{bookingHeader(firstBooking)}</span>
								<span className={firstStatus.className}>{firstStatus.label}</span>
							</div>
						) : null}
						{secondStatus ? (
							<div className="insurance-license-mobile-row">
								<span className="insurance-license-mobile-label">{bookingHeader(secondBooking)}</span>
								<span className={secondStatus.className}>{secondStatus.label}</span>
							</div>
						) : null}
						<div className="insurance-license-mobile-actions">
							<button
								type="button"
								className="insurance-license-action-link"
								disabled={removingPolicyId === policy.PublicLiabilityInsuranceId}
								onClick={() => onRemovePolicy(policy.PublicLiabilityInsuranceId)}
							>
								{removingPolicyId === policy.PublicLiabilityInsuranceId ? 'Removing...' : 'Remove'}
							</button>
						</div>
					</div>
				);
			})}
		</div>
	);
}
